/**
 * The release history, newest first. Versions are semver from here on:
 * major for breaking saves/protocol, minor for features, patch for fixes.
 * Dates are the ship dates from git history; entries before 1.0.0 are the
 * pre-versioning era reconstructed honestly rather than invented.
 */
export const CHANGELOG = [
  {
    v: '1.27.0',
    date: '2026-10-20',
    items: [
      'REDLINE: every cleared sector has a hard mode now. Same grid, a clock, no checkpoints',
      'Cross the clock and the run is over; die and you walk back from spawn while it runs',
      'WATCHTOWER\'s sentinels are at full reach in the red; PHOSPHOR rots in six seconds',
      'Own records, own ghosts, own world boards (look for the red pill on the sector grid)',
      'The clocks are seeded from the boards and will be tuned against what you run',
    ],
  },
  {
    v: '1.26.1',
    date: '2026-10-20',
    items: [
      'Stranded on a deep floor with no way up? The HUD now names the reboot control after a few still seconds',
      'The hint speaks your controls (R, RST, or the pad button you bound) and shows once per life',
    ],
  },
  {
    v: '1.26.0',
    date: '2026-09-26',
    items: [
      'RELAY chamber one: route a beam through portals to open a door, then rebuild the pair for a launch above your entrance',
      'Three required signals and a checkpoint beyond the door keep launch retries quick',
      'Beam emitters, sockets and powered gates are available in the level editor',
      'Gates allow a short grace period when power drops and stay open while the doorway is occupied',
    ],
  },
  {
    v: '1.25.1',
    date: '2026-09-26',
    items: [
      'Gauntlet bounce landings leave enough room to rise past the next deck, even with uneven frame times',
      'CONFLUX catches low portal flights earlier without changing the approach to its final drums',
    ],
  },
  {
    v: '1.25.0',
    date: '2026-09-21',
    items: [
      'CROSSFLOW: a new enclosed facility unlocked after SWITCHBACK',
      'Seven signals connect dogleg tunnels, an upper overlook, and four portal flights',
      'Bank onto offset landings, climb the Return Tower, then link two moves through the Exhaust wing',
      'Checkpoints preserve signals through retries; SWITCHBACK keeps its existing course',
    ],
  },
  {
    v: '1.24.0',
    date: '2026-09-20',
    items: [
      'SWITCHBACK: an enclosed trial loop unlocked after SKYBREAK',
      'Descend below the intake, follow the underworks, and launch back onto the walkway above your starting room',
      'Four required signals and checkpoint retries keep the three-floor route connected',
      'This first playable loop is a staging prototype for a larger stacked facility',
    ],
  },
  {
    v: '1.23.0',
    date: '2026-09-20',
    items: [
      'SKYBREAK: a six-part rooftop expedition, unlocked after SLIPSTREAM',
      'Eight required shards connect rooftop hops, crosswind flights, floating gardens and an updraft climb',
      'Pick the glass speed line or the open balcony, then dive through the tower and launch back above the skyline',
      'Every signal is a checkpoint; falls keep the shards you already earned',
      'Fast glass impacts keep their momentum, even when a slow frame crosses the whole break trigger',
    ],
  },
  {
    v: '1.21.1',
    date: '2026-09-14',
    items: [
      'Long runs count now: the board takes clears up to ten minutes, and records them whole',
      'It used to stop recording at five; a slow WATCHTOWER clear could never post a time',
      'When the board refuses a record you are told why, instead of silence',
      'Pausing no longer eats your portals: the rot clock stops when you do',
      'Big saves sync again: replays are packed to fit the upload limit, records always travel',
      'PHOSPHOR: the last gap of THE LONG DARK is crossable now; its panels faced the void',
      'Three signs stepped out of the walls they were clipping into (PHOSPHOR, DESCENT, VELOCITY)',
    ],
  },
  {
    v: '1.21.0',
    date: '2026-09-09',
    items: [
      'CHALLENGE A FRIEND: every campaign clear can become a link',
      'The link opens straight into your ghost. They race it, then send theirs back',
      'Works on any run, not just records; the link lives for six months',
      'Pasted into a chat it unfurls as "X ran FREEFALL in 7.47s. Beat it."',
    ],
  },
  {
    v: '1.20.1',
    date: '2026-09-06',
    items: [
      'Gauntlet depth records now survive uploading and merging progress between devices',
      'Your deepest run keeps its matching ghost when that replay is available',
    ],
  },
  {
    v: '1.20.0',
    date: '2026-09-02',
    items: [
      'TWO NEW SECTORS past PISTON, and they are the hard ones',
      'WATCHTOWER: sentinels sweep every open span. Stopping is what gets you shot',
      'Being seen halves your legs AND your jump, and the stair needs the jump',
      'PHOSPHOR: the grid is rotting. Your portals die nine seconds after you place them',
      'So shoot LATE. A portal placed early is gone before you reach it',
      'Fall slow in the dark, tag the wall behind you, and fly out of it',
    ],
  },
  {
    v: '1.19.0',
    date: '2026-08-27',
    items: [
      'THE RIVAL LEARNED THE COURSE: it races UPLINK, VELOCITY and DESCENT properly now',
      'No more standing in its own portal, no more humping a pit wall for a minute',
      'It dies like you do: hazards and acid kill it, and a stranded rival restarts',
      'It talks: real trash talk about the race you are actually having',
      'It gambles: at the UPLINK gate it picks the safe line or the fast one, depending',
      'It plays fair: on collect sectors the gate only counts with every shard',
      'Records train it. The line your ghost takes is a line the rival can learn',
      'Resume after ESC captures the mouse on its own now, no extra click',
    ],
  },
  {
    v: '1.18.0',
    date: '2026-08-26',
    items: [
      'MARATHON: the whole campaign, one clock, one board',
      'Deaths cost time, never progress; sector times bank at every gate',
      'No ghosts at this distance; the board is word-of-honor, like depth',
      'Medals mean something: pars recalibrated against the real record lines',
      'Some golds got harder; the clock did not change, the bar did',
      'UPLINK shows you the fling now: watch the hologram run it',
      'Feedback accepts emoji now (it was eating them and blaming the network)',
      'Reviewing a submission? EXIT returns you to the admin portal',
    ],
  },
  {
    v: '1.17.0',
    date: '2026-08-21',
    items: [
      'CHAPTER 2 BEGINS: three new sectors past CONFLUX, built on the new tech',
      'FRACTURE: glass momentum. FOUNDRY: the floor is the puzzle. PISTON: read the rhythm',
      'Longer runs, real checkpoints, courier logs on the walls',
      'UPLINK softened: the climb holds a checkpoint now; a fall never costs the fling',
    ],
  },
  {
    v: '1.16.1',
    date: '2026-08-21',
    items: [
      'Ion tech got teeth: beam and sentinel hits now SHOCK you for seconds',
      'Shocked means half speed and half jump, hops included; everyone feels it',
      'The old speed strip only stung sprinters; phone pilots never noticed',
    ],
  },
  {
    v: '1.16.0',
    date: '2026-08-21',
    items: [
      'NEW TECH: piston crushers slam on a cycle; a pin is fatal, a graze is not',
      'NEW TECH: sentinel turrets charge while they see you; the shot taxes speed',
      'Break line of sight or keep moving; cover genuinely works',
      'Editor: placing is sticky now; click repeatedly, Esc to stop',
    ],
  },
  {
    v: '1.15.0',
    date: '2026-08-21',
    items: [
      'NEW TECH: surface paint; boost strips, ice patches, acid puddles',
      'Boost shoves you along its chevrons; ice forgets friction locally',
      'Acid dissolves you on touch; hop over it or go around',
      'Editor: mutator presets are toggles now, lit while active',
    ],
  },
  {
    v: '1.14.0',
    date: '2026-08-21',
    items: [
      'NEW TECH: shear beams; an ion beam that taxes speed, not lives',
      'Cross one too fast and you keep moving, at walk speed, humiliated',
      'Beams can sweep: SPIN in the editor, already legal in submissions',
      'Editor: one-click mutator presets stamp daily math into your sector',
    ],
  },
  {
    v: '1.13.0',
    date: '2026-08-21',
    items: [
      'NEW TECH: decaying portals; they gutter, shrink, and rot away',
      'Levels can carry a portal lifetime (editor: PORTAL TTL, submittable)',
      'A new daily mutator joins the pool from Aug 23: DECAY',
      'The rival suffers the rot too, and has learned to re-shoot',
    ],
  },
  {
    v: '1.12.1',
    date: '2026-08-21',
    items: [
      'Every physics knob explains itself: hover a row for what it does and its stock value',
    ],
  },
  {
    v: '1.12.0',
    date: '2026-08-21',
    items: [
      'PHYSICS PLAYGROUND: every movement knob is tunable in the level editor',
      'Playtest runs your numbers through the real game; RESET restores stock',
      'Custom physics is playtest-only: submissions must run stock physics',
      'Fixed LOCKED-IN: mid-air banking ignored the lock since 1.4.0',
    ],
  },
  {
    v: '1.11.4',
    date: '2026-08-21',
    items: [
      'Your fresh record now shows on the results board immediately',
      'It was always saved; the board you saw was a stale cached copy',
      'Your own row highlights even if your callsign was typed lowercase',
    ],
  },
  {
    v: '1.11.3',
    date: '2026-08-20',
    items: [
      'A daily sweep now reviews boards and community content automatically',
      'Detection no longer depends on the dev happening to look',
    ],
  },
  {
    v: '1.11.2',
    date: '2026-08-20',
    items: [
      'Callsigns now have a hate-speech floor, enforced everywhere names appear',
      'One slur was removed from a board; its record and ghost are gone with it',
    ],
  },
  {
    v: '1.11.1',
    date: '2026-08-20',
    items: [
      'The telemetry learned that dying exists (deaths were invisible to it)',
      'Purely under the hood; still anonymous, still no identifiers',
    ],
  },
  {
    v: '1.11.0',
    date: '2026-08-20',
    items: [
      'NEW TECH: shatter panels; glass that only breaks above the printed speed',
      'Crash through and keep every bit of your momentum; too slow just thuds',
      'Already in the level editor palette, already legal in submissions',
    ],
  },
  {
    v: '1.10.0',
    date: '2026-08-20',
    items: [
      'REPLAY THEATER: WATCH any leaderboard ghost run its line, on loop',
      'Works on your own runs too; study the proof, then beat it',
    ],
  },
  {
    v: '1.9.0',
    date: '2026-08-20',
    items: [
      'Tell the dev things: FEEDBACK lives on the pause and end screens',
      'Anonymous like everything here; your sector and device class ride along',
    ],
  },
  {
    v: '1.8.0',
    date: '2026-08-20',
    items: [
      'Submitted sectors get reviewed faster: a proper admin portal landed',
      'Board moderation exists now: griefer entries can actually be removed',
    ],
  },
  {
    v: '1.7.0',
    date: '2026-08-20',
    items: [
      'Signs are legible: bigger by default, bolder small print, steadier glow',
      'The editor edits signs now: text, color and size, right in the panel',
      'Editor panel untangled: sector-wide settings live apart from your selection',
      'Env colors preview live while you drag the picker, not after',
    ],
  },
  {
    v: '1.6.0',
    date: '2026-08-19',
    items: [
      'Telemetry grew up: races, rival health and real-device performance',
      'Still anonymous by construction: no IDs, no IPs, country at most',
      'A private stats page for the maintainer, fed by the same data',
    ],
  },
  {
    v: '1.5.0',
    date: '2026-08-19',
    items: [
      'The level editor is open to everyone: LEVEL EDITOR on the title screen',
      'Built something good? Finish it from spawn, then SUBMIT it for review',
      'Accepted sectors ship in the campaign with their maker credited',
    ],
  },
  {
    v: '1.4.0',
    date: '2026-08-19',
    items: [
      'Air steering rebuilt: turning now banks your momentum instead of fighting it',
      'A landing light tracks where you will touch down; red means nowhere good',
      'The Gauntlet draws from the chunk pool it always claimed to use',
      'Fair warning: some steering-heavy records just became beatable',
    ],
  },
  {
    v: '1.3.0',
    date: '2026-08-17',
    items: [
      'Level editor: build your own sector in the browser (open #editor)',
      'Place, drag and tune every object; playtest from where you stand',
      'Ask the walker if your level is beatable; export a ready level file',
    ],
  },
  {
    v: '1.2.1',
    date: '2026-08-16',
    items: [
      'Android: back pauses your run and backs out of menus instead of quitting',
      'Wiping progress now asks for a new callsign, as it should have',
      'Uploading merges with your synced copy, so it can never blank it',
    ],
  },
  {
    v: '1.2.0',
    date: '2026-08-16',
    items: [
      'Play on another device: a sync code carries your progress across',
      'Merging never overwrites, so the best time of each sector survives',
      'No account, no email: the code is the whole credential',
    ],
  },
  {
    v: '1.1.0',
    date: '2026-08-15',
    items: [
      'MOMENTUM is installable: Add to Home Screen for a fullscreen app',
      'Plays offline after one visit (races and boards still need a network)',
    ],
  },
  {
    v: '1.0.1',
    date: '2026-08-15',
    items: [
      'Phone screens uncramped: no more buttons over the leaderboard',
      'Every menu scrolls instead of clipping its own edges',
    ],
  },
  {
    v: '1.0.0',
    date: '2026-08-15',
    items: [
      'Controls sub-menu: view and rebind the keyboard, mouse and gamepad',
      'Escape backs out of any menu; in a game it pauses, and again resumes',
      'Fixed a race where the game could pause itself with your mouse captured',
      'First-run callsign prompt; set your name without finding settings',
      'This changelog, and real version numbers to put in it',
    ],
  },
  {
    v: '0.10.0',
    date: '2026-08-14',
    items: [
      'First-flight training: device-aware hints that clear by doing',
      'Quick-pings, race history and live callsign rename in rooms',
      'Spectate got a first-person POV; touch sticks got a response curve',
      'Dynamic soundtrack: six vibes driven by your speed',
    ],
  },
  {
    v: '0.8.0',
    date: '2026-08-13',
    items: [
      'RACE ONLINE: rooms, sector votes, live replicas, spectate',
      'Gamepad support with Portal-style binds and pad-driven menus',
    ],
  },
  {
    v: '0.6.0',
    date: '2026-08-12',
    items: [
      'THE GAUNTLET: a daily 18-chunk tower, one life, depth boards',
      'Wind sectors ZEPHYR and SLIPSTREAM',
    ],
  },
  {
    v: '0.4.0',
    date: '2026-08-11',
    items: [
      'DAILY RUN: one sector + one mutator per day, its own board',
      'Falling aim assist: portals land where you will',
    ],
  },
  {
    v: '0.2.0',
    date: '2026-08-10',
    items: [
      'Ghost racing, world leaderboards, rival difficulty tiers',
      'Sectors 7-11: rings, gates, kinetic floors, gravity fields',
    ],
  },
  {
    v: '0.1.0',
    date: '2026-08-09',
    items: [
      'The first grid: six sectors, two portals, one AI rival',
    ],
  },
];
